import type { ReactNode } from "react";
import { View } from "react-native";
import { useTranslation } from "react-i18next";

import { isOfflineCode, loadErrorText } from "../loadErrorText";
import { InlineStatusHint } from "../primitives/InlineStatusHint";
import { LoadingIndicator } from "../primitives/LoadingIndicator";
import type { UiTheme } from "../theme";
import { makeProgressViewStyles } from "./progressViewStyles";

/** The title row over the host's session-load error, or a spinner while the
 *  sessions load (`loading`). Null once there is data: the card draws it.
 *  Shared by the Rhythm, the streak and the PR timeline widgets. `error` is
 *  the code (`api_error_500`, `api_offline`): the athlete reads words (#397). */
export function ProgressWidgetStatus({
  theme,
  titleRow,
  error,
  loading,
}: {
  theme: UiTheme;
  titleRow: ReactNode;
  error: string | null;
  loading: boolean;
}) {
  const { t } = useTranslation();
  const styles = makeProgressViewStyles(theme);
  if (error === null && !loading) return null;
  return (
    <View style={styles.rhythm}>
      {titleRow}
      {error !== null ? (
        <InlineStatusHint theme={theme} tone={isOfflineCode(error) ? "cached" : "error"} text={loadErrorText(t, error)} />
      ) : (
        <LoadingIndicator theme={theme} />
      )}
    </View>
  );
}
